/**
 * Airline filter component.
 */
define([
        'jQuery',
        'underscore',
        'library/fcse-widget/widget',
        'library/fcse-compatibility/object',
        'jquery.cookie'
    ], function ($, _, Widget, Object) {

        /**
         * Constructor
         * @param element
         * @constructor
         */
        var AirlineFilter = function(element) {
            var self = this;
            // %3B = ';'
            this._paramSeparator = ';';
            this._valueToString = function(value) {
                return _.isArray(value) ? value.join(self._paramSeparator) : value;
            };
            this._valueToArray = function(value) {
                return _.isString(value) ? value.split(self._paramSeparator) : value;
            };
            Widget.apply(this, arguments);

            // Store element
            this.element = $(element);
            this._init();
            this.setValueToUi();
        };

        AirlineFilter.prototype = $.extend(Object.create(Widget.prototype), {
            /**
             * Initialize AirlineFilter
             *
             * @private
             */
            _init: function() {
                this._registerClickHandler();
            },

            /**
             * Registers event handlers
             * @private
             */
            _registerClickHandler: function() {
                var self = this;
                $('[fcse-data-role="airline-filter-item"]', this.element).click(function(e){
                    e.stopPropagation();

                    var checkbox = $('.list-checkbox--checkbox', this),
                        value;

                    checkbox.prop('checked', checkbox.is(':checked'));
                    value = self.getValueFromUi();

                    if (value.excludedAirline.length > 0) {
                        $.cookie("excludedAirline", value.excludedAirline.join(self._paramSeparator), {
                            path    : '/',          //The value of the path attribute of the cookie
                            secure  : false
                        });
                    } else {
                        $.removeCookie("excludedAirline", {
                            path    : '/',          //The value of the path attribute of the cookie
                            secure  : false
                        });
                    }
                    // Setting value only after cookies are set
                    self.setValue(value);
                });
            },

            /**
             * {@inheritdoc}
             */
            setValueToUi: function() {
                var value = this._decodeValue(this.value);

                $('[fcse-data-role="airline-filter-item"]', this.element).each(function() {
                    var filterItem = $(this),
                        checkbox = $('.list-checkbox--checkbox', filterItem);

                    if (value.excludedAirline && $.inArray(filterItem.data('value'), value.excludedAirline) >= 0) {
                        checkbox.prop('checked', false);
                    } else {
                        checkbox.prop('checked', true);
                    }
                });
            },

            /**
             * {@inheritdoc}
             */
            getValueFromUi: function() {
                var params = {
                    airlineCodes: [],
                    excludedAirline: []
                };

                $('[fcse-data-role="airline-filter-item"]', this.element).each(function() {
                    var filterItem = $(this);
                    var checkbox = $('.list-checkbox--checkbox', filterItem);

                    if (checkbox.is(':checked')) {
                        params.airlineCodes.push(filterItem.data('value'))
                    } else {
                        params.excludedAirline.push(filterItem.data('value'));
                    }
                });

                return params;
            },

            /**
             * Sets value with encode, we do not want to allow arrays in query
             * @param value
             */
            setValue: function(value) {
                Widget.prototype.setValue.call(this, this._encodeValue(value));
            },

            /**
             * Value encoder
             * @param value
             * @returns {*}
             * @private
             */
            _encodeValue: function(value) {
                return this._valueConvertor(value, this._valueToString);
            },

            /**
             * Value decoder
             * @param value
             * @returns {*}
             * @private
             */
            _decodeValue: function(value) {
                return this._valueConvertor(value, this._valueToArray)
            },

            /**
             * Basic value converter
             * @param value
             * @param convertor
             * @returns {{}}
             * @private
             */
            _valueConvertor: function(value, convertor) {
                var result = {};

                if (_.isObject(value)) {
                    // Converting array values to strings understandable by server mappers
                    _.each(value, function(val, key) {
                        if (val) {
                            val = convertor(val);
                        }
                        result[key] = val;
                    });
                }
                return result;
            }
        });

        return AirlineFilter;
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/airlinefilter/airlineFilterWidget.js